<script lang="ts" setup>
import { AppAutocomplete } from '@/core/components';
import { debounce, keys } from 'lodash';

const place = defineModel<string | number | object>({ default: { full_name: '' } });

const props = withDefaults(
  defineProps<{
    label?: string;
    errorMessages?: string;
    placeId?: string;
  }>(),
  {
    label: 'Enter Location',
    errorMessages: '',
    placeId: '',
  }
);

const { pending, data, execute: searchLocation } = useGetData();
pending.value = false;

const autoSelectFirst = ref(false);

const places = ref([]);

if (props.placeId) {
  await searchLocation(`/places/${props.placeId}`);
  places.value = [data.value?.data];
  // place.value.full_name = data.value?.data.full_name;

  autoSelectFirst.value = true;
} else {
  if (keys(place.value).length === 1) {
    place.value = null;
  }
}

async function search(input: string | number | null) {
  if (input) {
    await searchLocation(`/places?input=${input}`);
    places.value = data.value?.data;

    autoSelectFirst.value = false;
  }
}
const debouncedSearch = debounce(search, 400);
</script>

<template>
  <AppAutocomplete
    v-model="place"
    item-title="full_name"
    item-value="place_id"
    hide-no-data
    return-object
    :auto-select-first="autoSelectFirst"
    :label="label"
    :items="places"
    :loading="pending"
    :error-messages="errorMessages"
    data-testid="google-place-input"
    @update:search="debouncedSearch($event)"
    v-bind="$attrs"
  />
</template>
